export const DEPARTURE_TEXT = {
    id: 'oe.attendeeLiveForm.departure',
    description: 'Label text',
    defaultMessage: 'Departure'
};

export const ARRIVAL_TEXT = {
    id: 'oe.attendeeLiveForm.arrival',
    description: 'Label text',
    defaultMessage: 'Arrival'
};

export const ORG_NAME_TEXT = {
    id: 'oe.attendeeLiveForm.orgName',
    description: 'Label text',
    defaultMessage: 'Org Name'
};

export const JOINED_TEXT = {
    id: 'oe.attendeeLiveForm.joined',
    defaultMessage: 'Joined',
    description: 'Label text',
};

export const REGISTRANTS_TEXT = {
    id: 'oe.attendeeLiveForm.registrants',
    defaultMessage: 'Registrants',
    description: 'Label text',
};

export const SEARCH_REGISTRANTS_TEXT = {
    id: 'oe.attendeeLiveForm.searchRegistrants',
    defaultMessage: 'Search Registrants',
    description: 'Search placeholder'
};

export const SEARCH_RESULT_TEXT = {
    id: 'oe.attendeeLiveForm.searchResult',
    defaultMessage: '{resultCount, plural, one {# Search Result} other {# Search Results}}',
    description: 'Search result text'
};